


























import Vue, { PropType } from 'vue'
import Dialog from '@/components/Dialog.vue'
import { UserStats } from '@/api/Auth/auth.interface'

export default Vue.extend({
  components: {
    appDialog: Dialog,
  },
  props: {
    item: Object as PropType<UserStats>,
  },
  computed: {
    customItem() {
      if (!this.item) {
        return {}
      }
      return {
        'topup.count': this.item.topups_count || '0',
        credit: '$ ' + this.item.topup_credit || '0.00',
        // 'remittance.count': this.item.remittance_count || '0',
      }
    },
  },
})
